import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const STAGES = [
  { no: "01", h: "Diagnose", p: "Weeks 1–2. We open the hood on your ads, funnel, product analytics and retention. You leave with a leak-audit no one on your team has time to do." },
  { no: "02", h: "Blueprint", p: "Weeks 3–4. A 90-day plan pinned to two numbers you can defend in any board meeting. Channels, creative, calendar, definition of done — all named, all owned." },
  { no: "03", h: "Ship", p: "Month 2 onwards. The people on our website — not their juniors — shipping the work every week on your Slack. Weekly stand-ups, bi-weekly strategy, monthly business review." },
  { no: "04", h: "Compound", p: "Month 4+. Winners scaled hard, losers killed faster, new bets always in the oven. Boring, on purpose. This is how growth actually compounds." },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process"
      className="relative border-t border-white/10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-[90rem] px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-white/65">
          / What your first 90 days look like
        </p>
        <h2 className="mt-5 max-w-3xl font-display text-4xl font-extrabold leading-[0.95] tracking-tighter text-white md:text-6xl">
          Four stages between{" "}
          <span className="font-serif-emph font-normal">hello</span>{" "}
          and your next growth quarter.
        </h2>

        <div className="mt-16 space-y-3 md:space-y-4">
          {STAGES.map((s, i) => (
            <motion.div
              key={s.no}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              data-testid={`stage-${s.no}`}
              className="grid gap-4 rounded-2xl border border-white/10 p-6 md:grid-cols-12 md:items-center md:gap-8 md:p-10"
            >
              <div className="flex items-center gap-6 md:col-span-3">
                <span className="font-mono text-sm text-white/75">{s.no}</span>
                <ArrowRight size={18} className="text-white/70 hidden md:block" />
              </div>
              <h3 className="font-display text-2xl font-bold tracking-tight text-white md:col-span-4 md:text-3xl">
                {s.h}
              </h3>
              <p className="text-sm leading-relaxed text-white/75 md:col-span-5">
                {s.p}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
